<template>
	<div class="product_calculator" id="product_calculator">

		<div class="product_calculator_header">
			<i class="fal fa-ruler-triangle fa-2x fa-flip-horizontal"></i>
			How much do I need? Use our calculator
			<i class="fas fa-chevron-down"></i>
		</div>
		<div class="product_calculator_inner">
			<div class="product_calculator_form">
				<label>
					Length
					<input type="number" min="0" max="5000" name="length" size="4" v-model="length" />
				</label>
				<label>
					Width
					<input type="number" min="0" max="5000" name="width" size="4" v-model="width" />
				</label>
				<label>
					Unit
					<div class="select_wrapper">
						<select name="x_y_unit" v-model="x_y_unit">
							<option value="meters">Meters</option>
							<option value="feet">Feet</option>
							<option value="yards">Yards</option>
						</select>
					</div>
				</label>
				<template v-if="this.calculator_type=='combo_volume' || this.calculator_type=='single_volume'">
					<label>
						Depth
						<input type="number" min="0" max="100" name="depth" size="4" v-model="depth" />
					</label>
					<label>
						Unit
						<div class="select_wrapper">
							<select name="z_unit" v-model="z_unit">
								<option value="cm">CM</option>
								<option value="inches">Inches</option>
							</select>
						</div>
					</label>
				</template>
			</div>

			<div class="product_calculator_result" v-if="this.combos.length >= 1">
				<template v-if="this.calculator_type=='combo_area' || this.calculator_type=='combo_volume'">
					<b>To cover {{ Math.round((calculated_area)*100)/100 }}m<sup>2</sup> you will need</b>
					<div class="product_calculator_row" v-for="(combo, combo_key) in this.combos">
						<div class="label" v-if="combo.tag">{{ combo.tag }}</div>
						<div class="product_calculator_combo_items">
							<div v-for="(variation, key) in combo.variations" v-if="combo.items[key] > 0" class="product_calculator_combo_item">
								<template v-if="calculator_type=='combo_volume'">
									<img :src="'/images/' + variation.snake_case + '.svg'">
									<br>
								</template>
								{{ variation.name }}<br>
								x {{ combo.items[key] }}
							</div>
						</div>
						<div class="product_calculator_combo_price">
							<template v-if="calculator_type=='combo_volume' || calculator_type=='single_volume'">
								<small>Covers {{ format_number((combo.coverage / depth) * base_depth) }}m<sup>2</sup></small>
							</template>
							<template v-else>
								<small>Covers {{ format_number(combo.coverage) }}m<sup>2</sup></small>
							</template>

							{{ format_currency(combo.price) }}<sup>*</sup>
						</div>
						<div class="product_calculator_combo_add" v-if="buyable==1">
							<button type="button" class="button solid upper green" v-on:click.prevent="addToBasket(combo_key, true)">Add&nbsp;To <br>Basket</button>
						</div>
					</div>
					<template v-if="calculator_type=='combo_area' || calculator_type=='single_area'">
						<br><b>Please allow 10% for cuts and wastage</b>
					</template>
				</template>

				<template v-if="this.calculator_type=='single_area' || this.calculator_type=='single_volume'">
					<b>To cover {{ Math.round((calculated_area)*100)/100 }}m<sup>2</sup> you will need <template v-if="this.combos.length > 1">one of the following</template></b>
					<div v-for="(variation, key) in this.combos" class="product_calculator_paving_row">
						<div class="product_calculator_paving_item">
							<b>{{ variation.name }}</b><br>
							x {{ variation.qty }}
							<template v-if="use_per_meter_pricing==true">m<sup><small>2</small></sup></template>
						</div>
						<div class="product_calculator_paving_price">
							{{ format_currency(calculateprice(variation)) }}<sup>*</sup>
						</div>
						<div class="product_calculator_paving_add" v-if="buyable==1">
							<button type="button" class="button solid upper green" v-on:click.prevent="addToBasket(key, false)">Add&nbsp;To Basket</button>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';

export default {

	directives: {debounce},

	props: [
		'product_id',
		'calculator_type',
		'dimensions',
		'base_depth',
		'buyable'
	],

	data: () => {
		return {
			length: 0,
			width: 0,
			x_y_unit: 'meters',
			depth: process.env.MIX_DEPTH,
			z_unit: 'cm',
			combos: [],
			use_per_meter_pricing: false,
			calculated_area: 0
		}
	},

	computed: {
	},

	watch: {
		length: debounce(function (val) {
			this.checkFields();
		}, 200),
		width: debounce(function (val) {
			this.checkFields();
		}, 200),
		x_y_unit: function (val) {
			this.checkFields();
		},
		depth: debounce(function (val) {
			if (this.calculator_type=='combo_volume' || this.calculator_type=='single_volume') {
				this.checkFields();
			}
		}, 200),
		z_unit: function (val) {
			if (this.calculator_type=='combo_volume' || this.calculator_type=='single_volume') {
				this.checkFields();
			}
		},
	},

	created() {
	},

	mounted() {
		if (this.dimensions.length != 0) {
			this.length = this.dimensions.length;
			this.width = this.dimensions.width;
			this.x_y_unit = this.dimensions.x_y_unit;
			this.depth = this.dimensions.depth;
			this.z_unit = this.dimensions.z_unit;
			$('.product_calculator_inner').show();
		}
	},

	methods: {
		// Map the Methods from the State Module
		...mapActions(['minicartRefresh']),

		checkFields: function(val) {
			// check if all fields are filled in
			if(isNaN(this.length)){ return; }
			if(isNaN(this.width)){ return; }
			if (this.calculator_type=='combo_volume' || this.calculator_type=='single_volume') {
				if(isNaN(this.depth)){ return }
			}

			// check that the values are greater than zero
			if (this.length == 0) { return; }
			if (this.width == 0) { return; }
			if (this.calculator_type=='combo_volume' || this.calculator_type=='single_volume') {
				if (this.depth == 0) { return; }
			}

			this.combos = [];

			// submit values to php to process
			axios.post('/ajax/calculator', {
				length: this.length,
				width: this.width,
				depth: this.depth,
				x_y_unit: this.x_y_unit,
				z_unit: this.z_unit,
				product_id: this.product_id
			}).then((response) => {
				this.calculated_area = response.data.pop();
				this.combos = response.data;

				if (this.combos[0].product && this.combos[0].product.use_per_meter_pricing==1) { this.use_per_meter_pricing = true; }else{ this.use_per_meter_pricing = false; }
			});
		},

		addToBasket: function(key, multiple) {
			if(multiple==true) {
				var variations = this.combos[key].variations;
			}else{
				var variations = [this.combos[key]];
			}

			axios.post('/ajax/addMultipleToBasket', {
				variations: variations
			}).then((response) => {
				this.$store.commit('updateMinicartRefreshStatus', true);
				this.$store.commit('updateBuyingOptionsRefreshStatus', true);
				this.popup();
			});
		},

		popup: function() {
			$.alert({
				title: 'Great!',
				content: 'Your items have been added to the basket.',
				buttons: {
					Continue: {
						text: 'Continue Shopping',
					},
					Basket: {
						text: 'View Basket',
						btnClass: 'btn-green',
						action: function () {
							window.location.href = '/basket'
						}
					}
				}
			});
		},

		format_currency: function(value){
			return "£" + this.numberWithCommas((Math.round( (value + 0.0001) * 100 ) / 100).toFixed(2));
		},

		addVat: function(num) {
			var rate = process.env.MIX_VAT_RATE;
			var multiply_by = 1 + (rate / 100);
			return parseFloat((num * multiply_by).toFixed(2));
		},

		format_number: function(value){
			return this.numberWithCommas((Math.round( (value + 0.0001) * 100 ) / 100).toFixed(2));
		},

		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		calculateprice: function (variation) {
			if (variation.product['use_per_meter_pricing'] == 1) {
				if ((+variation.qty) <= variation.coverage) {
					return (
						this.addVat(variation.pricing['product_portion'])
						* (+variation.qty)
					) + this.addVat(variation.pricing['delivery_portion']);
				} else {
					return this.addVat(variation.pricing['selling_from_price']) * (+variation.qty);
				}
			} else {
				return this.addVat(variation.pricing['selling_price']) * (+variation.qty);
			}
		}

	}
};
</script>
